module.exports = __webpack_public_path__ + "img/ESCRS_IOL_logo.4d0063c9.png";